import React from 'react';
import PropTypes from 'prop-types';
import styles from './JobInfoTag.module.scss';

type JobInfoTagProps = {
  children: React.ReactNode;
  testId?: string;
  icon?: React.ReactNode;
};

const JobInfoTag: React.FC<JobInfoTagProps> = ({ children, testId, icon }) => {
  return (
    <div className={styles.compWrap}>
      {icon && icon}
      <span data-testid={testId} className="small-body-text">
        {children}
      </span>
    </div>
  );
};

JobInfoTag.propTypes = {
  children: PropTypes.node.isRequired,
  testId: PropTypes.string,
  icon: PropTypes.node,
};

JobInfoTag.defaultProps = {
  icon: undefined,
  testId: undefined,
};

export default JobInfoTag;
